import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { PERSONAL_HUB_SECTION_FACTIONS_REPUTATIONS } from './personalHubRailConfig';
import { normalizeFactionItemCode } from './tools/personalHubFactionItemCode';

const PersonalHubNavigationContext = createContext(null);

export function PersonalHubNavigationProvider({
  children,
  onSelectSection,
  canOpenFactionsReputations = false,
}) {
  const [pendingFactionItemCode, setPendingFactionItemCode] = useState(null);

  const goToFactionReputation = useCallback(
    (factionItemCode) => {
      const code = normalizeFactionItemCode(factionItemCode);
      if (!code || !canOpenFactionsReputations) return false;
      setPendingFactionItemCode(code);
      onSelectSection(PERSONAL_HUB_SECTION_FACTIONS_REPUTATIONS);
      return true;
    },
    [canOpenFactionsReputations, onSelectSection]
  );

  const clearPendingFactionItemCode = useCallback(() => {
    setPendingFactionItemCode(null);
  }, []);

  const value = useMemo(
    () => ({
      goToFactionReputation,
      pendingFactionItemCode,
      clearPendingFactionItemCode,
      canOpenFactionsReputations,
    }),
    [
      goToFactionReputation,
      pendingFactionItemCode,
      clearPendingFactionItemCode,
      canOpenFactionsReputations,
    ]
  );

  return (
    <PersonalHubNavigationContext.Provider value={value}>
      {children}
    </PersonalHubNavigationContext.Provider>
  );
}

export function usePersonalHubNavigation() {
  return useContext(PersonalHubNavigationContext);
}
